import React from 'react'

const Footer = () => {
  return (
    <div className='footer'>
        <div className='bulb'>
            <div className='pic'>
               
                <h1>More than Software. Industry-Leading Support and Best Practice Advice.</h1>
            </div>
            
            <div className='footer-text'>
                
                <a href="/login">Get Started</a>
            </div>
        </div>

        <div className='footer-menu'>
            <h1>InternConnect</h1>
        </div>
        <hr />
        <div>
            <p className='text-center'>&#169; Copyright 2023 | All Right Reserved | InternConnect</p>
        </div>
    </div>
  )
}

export default Footer